import { configureStore, combineReducers } from '@reduxjs/toolkit';

import appReducer from 'state/app.state';
import conciergeReducer from 'state/concierge.state';
import callReducer from 'state/call.state';
import leadReducer from 'state/lead.state';
import scriptReducer from 'state/script.state';

const combinedReducer = combineReducers({
  app: appReducer,
  concierge: conciergeReducer,
  call: callReducer,
  lead: leadReducer,
  script: scriptReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === 'RESET_APP') {
    state = undefined;
  }

  if (action.type === 'RESET_LEAD') {
    state = {
      app: { ...state.app },
      concierge: { ...state.concierge, isOnCall: false },
    };
  }

  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
